import BaseModel from './BaseModel';
import ExclusionCount from './ExclusionCount';

export default class PrismaStats extends BaseModel {
  constructor(data = {}) {
    super(PrismaStats, data);
    this.recordsFromDatabase = data.recordsFromDatabase;
    this.recordsFromRegistry = data.recordsFromRegistry;
    this.recordsFromOther = data.recordsFromOther;
    this.recordsFromPriorRevisions = data.recordsFromPriorRevisions;
    this.duplicateRecords = data.duplicateRecords;
    this.ineligibleRecords = data.ineligibleRecords;
    this.recordsScreened = data.recordsScreened;
    this.recordsExcludedByReviewers = data.recordsExcludedByReviewers;
    this.recordsExcludedBySystem = data.recordsExcludedBySystem;
    this.recordsScreenedInPriorRevisionsReassessed =
      data.recordsScreenedInPriorRevisionsReassessed;
    this.recordsIncludedInPriorRevisionsExcluded =
      data.recordsIncludedInPriorRevisionsExcluded;
    this.reportsRetrieved = data.reportsRetrieved;
    this.reportsNotRetrieved = data.reportsNotRetrieved;
    this.reportsReviewed = data.reportsReviewed;
    this.reportsIncluded = data.reportsIncluded;
    this.reportsExcluded = data.reportsExcluded;
    this.reportsExcludedByReason =
      data.reportsExcludedByReason?.map(
        (item) => new ExclusionCount(item)
      ) ?? null;
    this.reportsReviewedInPriorRevisionsReassessed =
      data.reportsReviewedInPriorRevisionsReassessed;
    this.reportsIncludedInPriorRevisionsExcluded =
      data.reportsIncludedInPriorRevisionsExcluded;
    this.studiesAwaitingClassification =
      data.studiesAwaitingClassification;
    this.includedStudiesOngoing = data.includedStudiesOngoing;
  }

  totalNonDuplicateRecords() {
    return (
      this.recordsFromDatabase +
      this.recordsFromRegistry +
      this.recordsFromOther +
      this.recordsFromPriorRevisions -
      this.duplicateRecords
    );
  }

  totalExcluded() {
    return (
      this.recordsExcludedByReviewers +
      this.recordsExcludedBySystem +
      this.reportsExcluded
    );
  }

  totalRecordsExcluded() {
    return (
      this.recordsExcludedByReviewers + this.recordsExcludedBySystem
    );
  }

  totalPending() {
    return (
      this.totalNonDuplicateRecords() -
      this.reportsIncluded -
      this.totalExcluded()
    );
  }
}
